import React from 'react'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import themeData from './Theme/themeData'
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 2,
      retryDelay: attempt => attempt * 1000,
    },
  },
});

const importAll = r => r.keys().forEach(r)
importAll(require.context('./htmlEmail', true, /\.svg$/))

function Root() {
  const theme = extendTheme({ ...themeData })
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </QueryClientProvider>
  )
}

export default Root
